import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';


import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import { RPERolActividades } from '../rpe-rol-actividades/rpe-rol-actividades.model';

export const entityRPERolActividadesAdapter: EntityAdapter<RPERolActividades> =
  createEntityAdapter<RPERolActividades>({});

export interface EntityRPERolActividadesState
  extends EntityState<RPERolActividades> {
  isLoading?: boolean;
  error?: Error | null;
}

export const initialState: EntityRPERolActividadesState =
  entityRPERolActividadesAdapter.getInitialState({
    isLoading: false,
    error: null
  });
